import type { Namespace } from '../types';

// Generic attachments panel (R-144): evidence files for incidents, changes,
// work orders, transfer orders and receiving slips.
export const attachments = {
  attachmentKind: { de: 'Art des Anhangs', en: 'Attachment kind' },
  title: { de: 'Anhänge', en: 'Attachments' },
  empty: { de: 'Keine Anhänge', en: 'No attachments' },
  add: { de: 'Datei hinzufügen', en: 'Add file' },
  upload: { de: 'Hochladen', en: 'Upload' },
  uploading: { de: 'Wird hochgeladen…', en: 'Uploading…' },
  fieldKind: { de: 'Art', en: 'Kind' },
  download: { de: 'Herunterladen', en: 'Download' },
  remove: { de: 'Entfernen', en: 'Remove' },
  removeTitle: { de: 'Anhang „{name}“ entfernen?', en: 'Remove attachment “{name}”?' },
  removeMsg: {
    de: 'Der Anhang wird entfernt (Soft-Delete, nachvollziehbar).',
    en: 'The attachment is removed (soft delete, traceable).',
  },
  loadError: { de: 'Anhänge konnten nicht geladen werden', en: 'Failed to load attachments' },

  kind_photo: { de: 'Foto', en: 'Photo' },
  // R-244 — V8's two upload points: raising a change from an incident, and
  // resolving one. The approver can then SEE the fault rather than take the
  // technician's word for it.
  kind_diagnosis: { de: 'Diagnose', en: 'Diagnosis' },
  kind_resolution: { de: 'Behebung', en: 'Resolution' },
  kind_signature: { de: 'Unterschrift', en: 'Signature' },
  kind_delivery_note: { de: 'Lieferschein', en: 'Delivery note' },
  kind_certificate: { de: 'Zertifikat', en: 'Certificate' },
  kind_document: { de: 'Dokument', en: 'Document' },
  kind_other: { de: 'Sonstiges', en: 'Other' },

  uploadedBy: { de: 'von {who} · {when}', en: 'by {who} · {when}' },
  toastUploaded: { de: '„{name}“ hochgeladen', en: 'Uploaded “{name}”' },
  toastRemoved: { de: '„{name}“ entfernt', en: 'Removed “{name}”' },
  dropHint: { de: 'oder Datei hierher ziehen', en: 'or drop a file here' },
} satisfies Namespace;
